import AddressChangeDeclined from 'features/personalDetails/screens/ChangeAddress/AddressChangeDeclined/AddressChangeDeclined';
import React from 'react';

export default function Page() {
  return <AddressChangeDeclined />;
}
